exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\npre[data-v-52b3689c] {\n  background-color: white;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font-size: 14px;\n  line-height: 21px;\n  font-family: Roboto, sans-serif;\n  color: rgba(0, 0, 0, .87);\n  white-space: pre-wrap;\n}\n", ""]);

// exports
